import React, { useEffect, useState } from 'react'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // import styles
import { useDispatch, useSelector } from 'react-redux';
import { messageActions } from '../../_actions/message.actions';
import { userActions } from '../../_actions';


const MessageManagement = () => {

    const [value, setValue] = useState('')
    const dispatch = useDispatch();
    const {messageList} = useSelector((state) => state.users);
    console.log("111111",messageList);
    useEffect(() => {
        dispatch(userActions.getMessage());
    }, []);

    useEffect(() => {
        setValue(messageList?.message)
    }, [messageList]);

    const handleSave = () => {
        if (value === '') return;
        dispatch(messageActions.messageSend({ message: value }));
    }
    return (
        <>
            <div className="w-full p-3 bgcolor h-screen overflow-y-auto overflow-hidden">
                <div className="p-4 bg-white rounded-md mx-auto w-full">
                    <div className='w-full'>
                        <ReactQuill className='h-60' theme="snow" value={value} onChange={setValue} />
                    </div>
                    <div className='flex justify-end items-center lg:mt-12 mt-16 p-3'>
                        <button className='bgbtn text-white px-7 py-2 rounded w-36' onClick={handleSave}>Save</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MessageManagement